'use strict';

bbw.shared.MobileMenuTabsTrait = {

    _tabsLocState: undefined,

    _getMobileMenuTabName: function() {
        return 'menu';
    },

    _isMobileMenuLayout: function() {
        return this._bbwLayoutTypeSvc.isMobile();
    },

    _onMobileTabsStateChange: function(firstTab, state) {
        this.$scope.mobileTabsMenu = false;
        if (state.name === this._getMobileMenuTabName()) {
            if (this._isMobileMenuLayout()) {
                this.$scope.showTabs = true;
                this.$scope.mobileTabsMenu = true;
            } else {
                this._tabsLocState.setState(firstTab, undefined, undefined, true);
                state.name = firstTab;
                this.$scope.showTabs = false;
            }
            this.$rootScope.$broadcast(bbw.globalEvent.mobileBackHide);
        } else {
            this.$scope.showTabs = false;
            this.$rootScope.$broadcast(bbw.globalEvent.mobileBackShow);
        }
        if (this.$scope.tabs.$select) {
            this.$scope.tabs.$select(state.name);
        } else {
            this.$scope.defaultSelectedTab = state.name;
        }

        if (angular.isFunction(this._onMobileTabsStateChanged)) {
            //noinspection JSUnresolvedFunction
            this._onMobileTabsStateChanged(state);
        }
    },

    _initMobileMenuTabs: function() {
        var menuTabName = this._getMobileMenuTabName();

        this.$scope.tabs = {};
        this.$scope.tabNames = this._getTabNames();

        this.$scope.showTabs = true;

        var firstTab;

        Object.keys(this._getTabNames()).some(function(tab) {
            if (tab !== menuTabName) {
                firstTab = tab;
                return true;
            }
        });

        if (!firstTab) {
            throw new Error("First tab could not be determined");
        }

        var states;
        if (angular.isFunction(this._getTabLocStates)) {
            //noinspection JSUnresolvedFunction
            states = this._getTabLocStates();
        } else {
            states = this._getTabNames();
        }

        var tabsLocState = this._bbwLocationSvc.createLocState({
            defaultState: [this._defaultTab],
            states: states,
            onStateChange: this._onMobileTabsStateChange.bind(this, firstTab)
        });

        this.$scope.onTabSelected = function(name) {
            var currentStateName = tabsLocState.getCurrentState().name;
            if (name !== currentStateName) {
                tabsLocState.setState(name);
            }
        };

        bbw.onMobileBack(this.$scope, function() {
            this.$rootScope.$safeApply(function() {
                if (angular.isFunction(this._onMobileBack)) {
                    //noinspection JSUnresolvedFunction
                    this._onMobileBack();
                } else {
                    tabsLocState.setState(menuTabName);
                }
            }.bind(this));
        }.bind(this));

        var onResize = function() {
            if (!this._isMobileMenuLayout() && tabsLocState.getCurrentState().name === menuTabName) {
                this.$rootScope.$safeApply(function() {
                    tabsLocState.setState(firstTab, undefined, undefined, true);
                }.bind(this));
            }
        }.bind(this);

        window.addEventListener('resize', onResize);
        this.$scope.$on('$destroy', function() {
            window.removeEventListener('resize', onResize);
        });

        this._tabsLocState = tabsLocState;

        return tabsLocState.run();
    }

};
